import { Text } from '@taxdown/piccolo-web';
import { YayoyakiFormatter } from '@taxdown/kami-sama/dist/kamiSama/yayoyakiFormatter';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useGetUserFlexInfo } from 'Containers/Dashboard/hooks';
import { ValidationInfoProps } from './types';

const ValidationInfo = ({
  taxReturnResult,
  isFlex,
  filingInfo,
}: ValidationInfoProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const flexInfo = useGetUserFlexInfo();
  const taxReturnType = taxReturnResult?.taxReturnType || filingInfo?.recent?.taxReturnType;
  const amount = taxReturnResult?.taxReturnResult ?? filingInfo?.recent?.amount;
  return (
    <Text type="paragraphs" color="grey" size="XS_M_S">
      {t(`Amount.toReceive.validation.${taxReturnType}`, {
        price:
          isFlex && flexInfo
            ? YayoyakiFormatter.formatAmountMxn(
                Math.abs(taxReturnResult?.taxReturnResult ?? 0) - flexInfo.discountedPrice
              )
            : YayoyakiFormatter.formatAmountMxn(Math.abs(amount ?? 0)),
      })}
    </Text>
  );
};

export default ValidationInfo;
